import type { DispatchStatus, JobStage } from "@/data/types";

const DISPATCH_VISIBLE_STAGES = new Set<JobStage>([
  "Ready for Dispatch",
  "Available for Contractor Assignment",
  "Ready for Scheduling",
  "Assigned and Dispatched",
]);

const DISPATCH_VISIBLE_STATUSES = new Set<DispatchStatus>([
  "Ready for Dispatch",
  "Sent to Contractor Network",
  "Awaiting Response",
  "Accepted",
  "Assigned",
]);

export function isDispatchVisible(currentStage?: string | null, dispatchStatus?: string | null): boolean {
  const stage = (currentStage ?? "") as JobStage;
  const status = (dispatchStatus ?? "") as DispatchStatus;
  return DISPATCH_VISIBLE_STAGES.has(stage) || DISPATCH_VISIBLE_STATUSES.has(status);
}

export { DISPATCH_VISIBLE_STAGES, DISPATCH_VISIBLE_STATUSES };

